import { useTranslation } from "react-i18next";
import { connectModal } from "redux-modal";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";
import BMXConfirmModal from "../../../../Components/Modals/BMXConfirmModal/BMXConfirmModal";
import { useState } from "react";
import ConfirmServiceClaimModalForm from "../../ConfirmModalsForms/ConfirmServiceClaimModalForm/ConfirmServiceClaimModalForm";

const ConfirmServiceClaimModal = (props) => {
  const { handleHide, show, confirmButtonName, initialValues } = props;
  const formName = "ConfirmServiceClaimModal";
  const { t } = useTranslation();

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCustomFaVatNumber, setCustomFaVatNumber] = useState(false);

  const buttons = () => {
    return (
      <>
        <BMXButton
          data-cy="submit"
          type="subbmit"
          buttontype="Button"
          bmxclass="secondary background"
          form={formName}
        >
          {confirmButtonName ? t(`${confirmButtonName}`) : t("global:yes")}
        </BMXButton>
      </>
    );
  };

  return (
    <BMXConfirmModal
      open={show}
      width={"500px"}
      height={"250px"}
      onClose={handleHide}
      buttons={buttons()}
      cancel={
        Boolean(initialValues?.claimNumber) ||
        Boolean(isError) ||
        Boolean(isLoading)
          ? "global:exit"
          : "global:reckoning.no"
      }
    >
      <ConfirmServiceClaimModalForm
        {...props}
        isError={isError}
        setIsError={setIsError}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        formName={formName}
        handleHide={handleHide}

        // isCustomFaVatNumber={isCustomFaVatNumber}
      />
    </BMXConfirmModal>
  );
};

export default connectModal({ name: "ConfirmServiceClaimModal" })(
  ConfirmServiceClaimModal,
);
